import React, { useState, useEffect, useRef, use, useCallback } from "react";
import "./print.css";

import { useReactToPrint } from "react-to-print";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import moment from "moment";
import DutyPostingService from "../services/dutyposting,service";

import { logsheet } from "../logsheet";

const DutyDetails = ({ data, data1, data2, isDrv, isCond, isPresent, currentIndex }) => {
  const componentRef = useRef();

  const [dutyData1, setDutyData1] = useState([]);
  const [dutyData2, setDutyData2] = useState([]);
  const [breakStop, setBreakStop] = useState("");
  const [breakStart, setBreakStart] = useState("");
  const [breakEnd, setBreakEnd] = useState("");
  const [totalKM, setTotalKM] = useState(0);

  const [isDrvAllocated, setIsDrvAllocated] = useState("");
  const [isCondAllocated, setIsCondAllocated] = useState("");

  const [logsheetData, setLogsheetData] = useState([]);

  // console.log("data", data)

  const currentDate = new Date();

  const handleAfterPrint = React.useCallback(() => {
    console.log("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = React.useCallback(() => {
    console.log("`onBeforePrint` called");
    return Promise.resolve();
  }, []);

  const printFn = useReactToPrint({
    contentRef: componentRef,
    documentTitle: "AwesomeFileName",
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  const fetchDutyTripInfo = useCallback((workno, data) => {
    const payload = {
      dutynum: isPresent ? data.narration : data.workno,
    };

    // console.log("dutynum", workno)

    DutyPostingService.getdutytripinfo(payload)
      .then((resp) => {
        if (resp.data) {
          // console.log(resp.data);
          const part1 = resp.data.filter((item) => item.breacksts === "1");
          const part2 = resp.data.filter((item) => item.breacksts === "2");
          setDutyData1(part1);
          setDutyData2(part2);

          const lastStop = part1[part1.length - 1].end_loc;
          const hours = part2[0].start_time.split(".")[0] * 60;
          const mins = part2[0].start_time.split(".")[1];
          const resultMins = parseInt(hours) + parseInt(mins) - 30;

          const diffHours = Math.floor(resultMins / 60);
          const diffMins = parseInt(resultMins) - parseInt(diffHours) * 60;

          const breakEndTime = parseFloat(part2[0].start_time);

          const breakStartTime = `${diffHours}:${diffMins}`;

          const totalKMs = resp.data.reduce(
            (accumulator, current) =>
              accumulator + parseFloat(current.killomiter),
            0
          );

          setBreakStart(breakStartTime);
          setBreakEnd(breakEndTime.toFixed(2));
          setBreakStop(lastStop);
          setTotalKM(totalKMs);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  const convertToMarNos = (engNo) => {
    const marNos = {
      0: "०",
      1: "१",
      2: "२",
      3: "३",
      4: "४",
      5: "५",
      6: "६",
      7: "७",
      8: "८",
      9: "९",
    };
    return (
      engNo &&
      engNo
        .toString()
        .split("")
        .map((num) => marNos[num] || num)
        .join("")
    );
  };

  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  const year = today.getFullYear();

  let formattedDate = `${year}-${month}-${day}`;

  useEffect(() => {
    const data = logsheet.filter((item) => item.depo === "wagle");
    setLogsheetData(data[0].tableData);
  }, []);

  useEffect(() => {
    // console.log("cond1", isDrvAllocated, isCondAllocated);

    if (isCondAllocated === "2") {
      toast.warn("Conductor is already allocated to another Duty!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else if (isDrvAllocated === "2") {
      toast.warn("Driver is already allocated to another Duty!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else if (
      (isDrvAllocated === "1" && isCondAllocated === "1") ||
      dutyData1.length > 0 ||
      dutyData2.length > 0
    ) {
      printFn();
    }
  }, [dutyData1, dutyData2, isDrvAllocated, isCondAllocated]);

  return (
    <>
      <div className="a4-page" ref={componentRef}>
        <div className="header-flex">
          {Array.isArray(logsheetData)
            ? logsheetData.map((item, index) => {
                return (
                  <>
                    <div className="custom-flex">
                      {index !== 4 ? (
                        <div className="left">
                          <span
                            style={{ fontWeight: index === 0 ? "bold" : "" }}
                          >
                            {convertToMarNos(item.left)}
                          </span>
                          {index === 1 ? (
                            <>{convertToMarNos(data.routecode)}</>
                          ) : index === 2 ? (
                            <>{convertToMarNos(data.afterSrNO)}</>
                          ) : index === 3 ? (
                            <>
                              {convertToMarNos( 
                                data.workno && data.workno.split("/")[1]
                              )}
                            </>
                          ) : (
                            <></>
                          )}
                        </div>
                      ) : (
                        <></>
                      )}

                      <div
                        className="center"
                        style={{ marginLeft: index === 4 ? "50px" : "" }}
                      >
                        <span style={{ fontWeight: index === 0 ? "bold" : "" }}>
                          {convertToMarNos(item.center)}
                        </span>
                      </div>
                      {index !== 4 ? (
                        <div className="right">
                          <span
                            style={{ fontWeight: index === 0 ? "bold" : "" }}
                          >
                            {convertToMarNos(item.right)}
                            {index === 1 ? (
                              <>
                                {convertToMarNos(
                                  moment(new Date(currentDate)).format(
                                    "DD-MM-YYYY"
                                  )
                                )}
                              </>
                            ) : index === 2 ? (
                              <>
                                {convertToMarNos(
                                  data1 && data1.length > 0
                                    ? data1[0].driverNo
                                    : data.driverNo
                                )}
                              </>
                            ) : index === 3 ? (
                              <>
                                {convertToMarNos(
                                  data2 && data2.length > 0
                                    ? data2[0].condNo
                                    : data.conductorNo
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                          </span>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </>
                );
              })
            : null}
        </div>

        <div className="">
          <table>
            <thead>
              <tr>
                <td>अ</td>
                <td>बस</td>
                <td colSpan={2}>मार्ग</td>
                <td>नियत</td>
                <td>बस प्रत्यक्ष</td>
                <td>नियत</td>
                <td>प्रत्यक्ष</td>
                <td>शेरा व वाह.</td>
              </tr>
              <tr>
                <td>क्र</td>
                <td>क्रमांक</td>
                <td className="colspan">पासून</td>
                <td>पर्यंत</td>
                <td>किमी</td>
                <td>आगमन</td>
                <td>वेळ</td>
                <td>निर्गमन</td>
                <td>नियं सही</td>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(dutyData1)
                ? dutyData1.map((item, index) => {
                    return (
                      <tr>
                        <td>{convertToMarNos(index + 1)}</td>
                        <td></td>
                        <td>{item.start_loc}</td>
                        <td>{item.end_loc}</td>
                        <td>{convertToMarNos(item.killomiter)}</td>
                        <td></td>
                        <td>{convertToMarNos(item.start_time)}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    );
                  })
                : null}
              <tr>
                <td colSpan={4}>
                  विश्रांति {convertToMarNos(breakStart)} ते{" "}
                  {convertToMarNos(breakEnd)} {breakStop} येथे
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
              {Array.isArray(dutyData2)
                ? dutyData2.map((item, index) => {
                    return (
                      <tr>
                        <td>{convertToMarNos(dutyData1.length + index + 1)}</td>
                        <td></td>
                        <td>{item.start_loc}</td>
                        <td>{item.end_loc}</td>
                        <td>{convertToMarNos(item.killomiter)}</td>
                        <td></td>
                        <td>{convertToMarNos(item.start_time)}</td>
                        <td></td>
                        <td></td>
                      </tr>
                    );
                  })
                : null}
              <tr className="no-border">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td>{convertToMarNos(totalKM.toFixed(2))}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
          {/* <p
            style={{
              fontWeight: "bold",
              display: "flex",
              alignItems: "end",
              justifyContent: "end",
            }}
          >
            कामगिरी संपण्याची नियोजित वेळ
          </p> */}
        </div>
      </div>
      {/* {data[0]} */}

      {isDrv && (data.driverPresenty === "1" || data1.length > 0 || isPresent) ? (
        <>
          <button
            className="action print active"
            onClick={(e) => {
              fetchDutyTripInfo(data.workno, data);
            }}
          >
            <span>
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.95837 3.95817C3.95837 3.52095 4.31282 3.1665 4.75004 3.1665H14.25C14.6873 3.1665 15.0417 3.52095 15.0417 3.95817V8.70817C16.3534 8.70817 17.4167 9.77146 17.4167 11.0832V14.2498C17.4167 15.5615 16.3534 16.6248 15.0417 16.6248H3.95837C2.64669 16.6248 1.58337 15.5615 1.58337 14.2498V11.0832C1.58337 9.77146 2.6467 8.70817 3.95837 8.70817V3.95817ZM3.95837 10.2915C3.52115 10.2915 3.16671 10.6459 3.16671 11.0832V14.2498C3.16671 14.6871 3.52115 15.0415 3.95837 15.0415H15.0417C15.4789 15.0415 15.8334 14.6871 15.8334 14.2498V11.0832C15.8334 10.6459 15.4789 10.2915 15.0417 10.2915V11.8748C15.0417 12.3121 14.6873 12.6665 14.25 12.6665H4.75004C4.31282 12.6665 3.95837 12.3121 3.95837 11.8748V10.2915ZM5.54171 4.74984V9.49984V11.0832H13.4584V9.49984V4.74984H5.54171ZM7.12504 7.12484C7.12504 6.68762 7.47949 6.33317 7.91671 6.33317H11.0834C11.5206 6.33317 11.875 6.68762 11.875 7.12484C11.875 7.56206 11.5206 7.9165 11.0834 7.9165H7.91671C7.47949 7.9165 7.12504 7.56206 7.12504 7.12484ZM7.12504 9.49984C7.12504 9.0626 7.47949 8.70817 7.91671 8.70817H11.0834C11.5206 8.70817 11.875 9.0626 11.875 9.49984C11.875 9.93707 11.5206 10.2915 11.0834 10.2915H7.91671C7.47949 10.2915 7.12504 9.93707 7.12504 9.49984Z"
                  fill="var(--primary-color)"
                />
              </svg>
            </span>
          </button>
        </>
      ) : isCond && (data.conductorPresenty === "1" || data2.length > 0 || isPresent || (data.conductorPresenty === "0" && currentIndex === 2)) ? ( <>
          <button
            className="action print active"
            onClick={(e) => {
              fetchDutyTripInfo(data.workno, data);
            }}
          >
            <span>
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.95837 3.95817C3.95837 3.52095 4.31282 3.1665 4.75004 3.1665H14.25C14.6873 3.1665 15.0417 3.52095 15.0417 3.95817V8.70817C16.3534 8.70817 17.4167 9.77146 17.4167 11.0832V14.2498C17.4167 15.5615 16.3534 16.6248 15.0417 16.6248H3.95837C2.64669 16.6248 1.58337 15.5615 1.58337 14.2498V11.0832C1.58337 9.77146 2.6467 8.70817 3.95837 8.70817V3.95817ZM3.95837 10.2915C3.52115 10.2915 3.16671 10.6459 3.16671 11.0832V14.2498C3.16671 14.6871 3.52115 15.0415 3.95837 15.0415H15.0417C15.4789 15.0415 15.8334 14.6871 15.8334 14.2498V11.0832C15.8334 10.6459 15.4789 10.2915 15.0417 10.2915V11.8748C15.0417 12.3121 14.6873 12.6665 14.25 12.6665H4.75004C4.31282 12.6665 3.95837 12.3121 3.95837 11.8748V10.2915ZM5.54171 4.74984V9.49984V11.0832H13.4584V9.49984V4.74984H5.54171ZM7.12504 7.12484C7.12504 6.68762 7.47949 6.33317 7.91671 6.33317H11.0834C11.5206 6.33317 11.875 6.68762 11.875 7.12484C11.875 7.56206 11.5206 7.9165 11.0834 7.9165H7.91671C7.47949 7.9165 7.12504 7.56206 7.12504 7.12484ZM7.12504 9.49984C7.12504 9.0626 7.47949 8.70817 7.91671 8.70817H11.0834C11.5206 8.70817 11.875 9.0626 11.875 9.49984C11.875 9.93707 11.5206 10.2915 11.0834 10.2915H7.91671C7.47949 10.2915 7.12504 9.93707 7.12504 9.49984Z"
                  fill="var(--primary-color)"
                />
              </svg>
            </span>
          </button>
        </>) : (
        <>
          <button className="action print">
            <span>
              <svg
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.95837 3.95817C3.95837 3.52095 4.31282 3.1665 4.75004 3.1665H14.25C14.6873 3.1665 15.0417 3.52095 15.0417 3.95817V8.70817C16.3534 8.70817 17.4167 9.77146 17.4167 11.0832V14.2498C17.4167 15.5615 16.3534 16.6248 15.0417 16.6248H3.95837C2.64669 16.6248 1.58337 15.5615 1.58337 14.2498V11.0832C1.58337 9.77146 2.6467 8.70817 3.95837 8.70817V3.95817ZM3.95837 10.2915C3.52115 10.2915 3.16671 10.6459 3.16671 11.0832V14.2498C3.16671 14.6871 3.52115 15.0415 3.95837 15.0415H15.0417C15.4789 15.0415 15.8334 14.6871 15.8334 14.2498V11.0832C15.8334 10.6459 15.4789 10.2915 15.0417 10.2915V11.8748C15.0417 12.3121 14.6873 12.6665 14.25 12.6665H4.75004C4.31282 12.6665 3.95837 12.3121 3.95837 11.8748V10.2915ZM5.54171 4.74984V9.49984V11.0832H13.4584V9.49984V4.74984H5.54171ZM7.12504 7.12484C7.12504 6.68762 7.47949 6.33317 7.91671 6.33317H11.0834C11.5206 6.33317 11.875 6.68762 11.875 7.12484C11.875 7.56206 11.5206 7.9165 11.0834 7.9165H7.91671C7.47949 7.9165 7.12504 7.56206 7.12504 7.12484ZM7.12504 9.49984C7.12504 9.0626 7.47949 8.70817 7.91671 8.70817H11.0834C11.5206 8.70817 11.875 9.0626 11.875 9.49984C11.875 9.93707 11.5206 10.2915 11.0834 10.2915H7.91671C7.47949 10.2915 7.12504 9.93707 7.12504 9.49984Z"
                  fill="rgba(167, 158, 183, 1)"
                />
              </svg>
            </span>
          </button>
        </>
      )}
    </>
  );
};

export default DutyDetails;
